export default {
  graduation: {
    type: Object,
    default: () => ({})
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/components/professional/components/graduations/resources/props.js